/**
 * Product Thumb Image Error Handler Listener
 *
 * Binds thumbnail image error events and forwards failures to the fallback handler.
 */

import type { ProductThumbImageErrorHandler } from "./product-thumb-image-error-handler-handler";

interface ProductThumbImageErrorHandlerListenerDeps {
    handler: ProductThumbImageErrorHandler;
}

class ProductThumbImageErrorHandlerListener {
    public handler: ProductThumbImageErrorHandler;

    public constructor(deps: ProductThumbImageErrorHandlerListenerDeps) {
        this.handler = deps.handler;
    }

    public register(): void {
        document.addEventListener(
            "error",
            (event) => {
                this.handler.handleImageError(event);
            },
            true,
        );
    }
}

export { ProductThumbImageErrorHandlerListener };
